module.exports = __webpack_public_path__ + "img/4931661.png";